import '../style.scss';
import { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import 'react-phone-input-2/lib/style.css';
import { IEditReportState, IResultsAndBenefitsTab, IResultsAndBenefitsItem, IMetadataModalityTab } from '../models/IEditReportState';
import { IRefPledgeEcosystemTypeFeature, IRefInterventionType } from '../models/IRefFeature';
import { IFeature } from '@esri/arcgis-rest-types';
import ConfigService from '../../../../shared/configService';
import Select, { MultiValue } from 'react-select';
import QueryService from '../../../../shared/queryService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Modal } from 'react-bootstrap';
import { IRefTierFeature, IRefCO2EstimationSystem, IRefJobMeasureUnit } from '../models/IRefFeature';
import Accordion from 'react-bootstrap/Accordion';
import Utils from '../../../../shared/utils';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';


const ResultsAndBenefits = (props: {state: IEditReportState, setState: Function, validateData: Function}) => {
  const {t} = useTranslation('reports');

  // State
  interface ILocalState {
    reportRBLayerIndex: number;
    reportRBJobsLayerIndex: number;
    refPledgeEcosystemTypeFeatures: IRefPledgeEcosystemTypeFeature[];
    refInterventionTypeFeatures: IRefInterventionType[];
    tiersFeatures: IRefTierFeature[];
    refCO2EstimationSystemFeatures: IRefCO2EstimationSystem[],
    refJobMeasureUnitFeatures: IRefJobMeasureUnit[],
    otherCO2EstimationSystemInputEnabled: boolean,
    hectaresUnderRestorationTab: {
      isActive: boolean;
      isDisabled: boolean;
    },
    climateImpactsTab:{
      isActive: boolean;
      isDisabled: boolean;
    },
    biodiversityImpactsTab:{
      isActive: boolean;
      isDisabled: boolean;
    },
    socioEconomicImpactsTab:{
      isActive: boolean;
      isDisabled: boolean;
    },
    treeData: any[]
  }

  const [localState, setTheLocalState] = useState<ILocalState>({
    reportRBLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportRb.index,
    reportRBJobsLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportRbJobs.index,
    refPledgeEcosystemTypeFeatures: [],
    refInterventionTypeFeatures: [],
    tiersFeatures: [],
    refCO2EstimationSystemFeatures: [],
    refJobMeasureUnitFeatures: [],
    otherCO2EstimationSystemInputEnabled: false,
    hectaresUnderRestorationTab: {
      isActive: true,
      isDisabled: false
    },
    climateImpactsTab:{
      isActive: false,
      isDisabled: false
    },
    biodiversityImpactsTab:{
      isActive: false,
      isDisabled: false
    },
    socioEconomicImpactsTab:{
      isActive: false,
      isDisabled: false
    },
    treeData: []
  });

  // Confirm dialog
  const [showRevertToGlobalDialog, setRevertToGlobalDialogShow] = useState(false);

  // Use effect
  useEffect(() => {
    //Set tabs state
    enableDisableTabs();

    const obj: IEditReportState = { ...props.state } as IEditReportState;
    const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;

    if(subObj && !subObj.resultsAndBenefitsItems?.length) {
      addResultsAndBenefitsItem(true);
    }

    //Reference table
    getRefFeatures();
  }, []);
  
  /**
   * Enable disable tab
   * @param index 
   */
   const enableDisableTabs = () => {
    const obj: ILocalState = { ...localState };

    obj.hectaresUnderRestorationTab.isDisabled = props.state.metadataModalityTab?.report_type === ConfigService.getConfig().agol.referenceTables.REF_MODALITY.snapshotValue && !props.state.metadataModalityTab?.benefitsHectaresRestorOn;
    obj.climateImpactsTab.isDisabled = props.state.metadataModalityTab?.report_type === ConfigService.getConfig().agol.referenceTables.REF_MODALITY.snapshotValue && !props.state.metadataModalityTab?.benefitsClimateImpactOn;
    obj.biodiversityImpactsTab.isDisabled = props.state.metadataModalityTab?.report_type === ConfigService.getConfig().agol.referenceTables.REF_MODALITY.snapshotValue && !props.state.metadataModalityTab?.benefitsBiodivImpactOn;
    obj.socioEconomicImpactsTab.isDisabled = props.state.metadataModalityTab?.report_type === ConfigService.getConfig().agol.referenceTables.REF_MODALITY.snapshotValue && !props.state.metadataModalityTab?.benefitsSocioEcoImpactOn;

    obj.hectaresUnderRestorationTab.isActive = true;    

    setTheLocalState(obj);   
  }
    
  /**
   * Get reference list
   */
   const getRefFeatures = async () => {

    // const ecosystemTypeFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index);
    // const interventionTypes: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_INTERVENTION_TYPE.index);
    // const tierFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_TIERS.index);
    // const cO2EstimationSystemFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_CO2_ESTIMATION_SYSTEM.index);
    // const measureUnitFeaturesFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_JOB_MEASURE_UNIT.index);
    

    //Ref data
    const countryFilter = "reporting_entity_type = '1' OR reporting_entity_type = '1,2'";
    //const ecosystemTypeFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index);
    const ecosystemTypeFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index), countryFilter, false, '*','');
    //const interventionTypes: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_INTERVENTION_TYPE.index);
    const interventionTypes: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_INTERVENTION_TYPE.index), countryFilter, false, '*','');
    //const tierFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_TIERS.index);
    const tierFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_TIERS.index), countryFilter, false, '*','');
    //const cO2EstimationSystemFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_CO2_ESTIMATION_SYSTEM.index);
    const cO2EstimationSystemFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_ESTIMATION_SYSTEM.index), countryFilter, false, '*','');
    const measureUnitFeaturesFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_JOB_MEASURE_UNIT.index);
    
    const obj: ILocalState = { ...localState };
    obj.refPledgeEcosystemTypeFeatures = ecosystemTypeFeatures.map((feat: IFeature) => feat.attributes as IRefPledgeEcosystemTypeFeature);
    obj.refInterventionTypeFeatures = interventionTypes.map((feat: IFeature) => feat.attributes as IRefInterventionType);
    obj.tiersFeatures = tierFeatures.map((feat: IFeature) => feat.attributes as IRefTierFeature);
    obj.refCO2EstimationSystemFeatures = cO2EstimationSystemFeatures.map((feat: IFeature) => feat.attributes as IRefCO2EstimationSystem);
    obj.refJobMeasureUnitFeatures = measureUnitFeaturesFeatures.map((feat: IFeature) => feat.attributes as IRefJobMeasureUnit);
    

    // Get layer infos
    await QueryService.getLayerFieldsInfos(localState.reportRBLayerIndex);
    await QueryService.getLayerFieldsInfos(localState.reportRBJobsLayerIndex);

    const filtered = obj.refInterventionTypeFeatures
    .filter((i: IRefInterventionType) => {
      //return (props.state.restorationPledgeTab?.ecosystems || '').split(',').indexOf(i.ecosystem_id || '---') !== -1
      return (props.state.restorationPledgeTab?.ecosystems || '').indexOf(i.ecosystem_id || '---') !== -1
    });

    obj.treeData = createIntervTypesDataTree(filtered);

    const selectedItem:IResultsAndBenefitsItem | undefined = getSelectedResultsAndBenefitsItem();

    if(selectedItem && selectedItem.hectaresUnderRestorationTab && selectedItem.hectaresUnderRestorationTab.ha_intervention_types) {
      const ids = selectedItem.hectaresUnderRestorationTab.ha_intervention_types.split(',').map(i => Number(i));
      setSelectedInterventionTypes(obj.treeData, ids);
    }

    setTheLocalState(obj);
  };

  /**
   * Get selected results and benefits item
   * @returns 
   */
   const getSelectedResultsAndBenefitsItem = (): IResultsAndBenefitsItem | undefined  => {
    if(props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;

      return subObj.resultsAndBenefitsItems?.find( (p: IResultsAndBenefitsItem, i: number) => p.isActive);
    }
    
    return undefined;
  }

  /**
   * Get selected results and benefits item index
   * @returns 
   */
   const getSelectedResultsAndBenefitsItemIndex = (): number => {
    if(props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;

      return (subObj.resultsAndBenefitsItems || []).findIndex( (p: IResultsAndBenefitsItem) => p.isActive);
    }
    
    return -1;
  }

  /**
   * Set parent state
   * @param tabIndex
   * @param prop
   * @param value 
   */
   const setParentState = (prop: string, value: any) => {

    if(props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;

      if(subObj) {
        (subObj as any)[prop] = value;
        
        obj.resultsAndBenefitsTab = subObj;
        props.setState(obj);
      }
    }
  }

  /**
   * Handle breakdown or revert report
   */
  const handleBreakdownOrRvertReportClick = async () => {
    handleRevertToGlobalDialogShow();
  }

  /**
   * Handle breakdown or revert report confirm
   */
  const handleBreakdownOrRvertReportConfirm = async () => {
    let features: IFeature[] = [];
    //let countryLevel: boolean = true;

    // 1) Global mode
    if(props.state.resultsAndBenefitsTab?.isGlobalMode) {
      // State level
      if(props.state && props.state.report?.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name1]) {
        //countryLevel = false;

        features = await QueryService.queryGADMFeatures(ConfigService.getConfig().agol.gadmLayers.gadm_2.index, 
        `${ConfigService.getConfig().agol.gadmLayers.gadm_2.fields.name1} ASC`,
        ConfigService.getConfig().agol.gadmLayers.gadm_1.fields.gid0,
        props.state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid0],
        ConfigService.getConfig().agol.gadmLayers.gadm_2.fields.gid1,
        props.state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid1]
        );
      }

      // Country level
      else if(props.state && props.state.report?.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name0]) {
        features = await QueryService.queryGADMFeatures(ConfigService.getConfig().agol.gadmLayers.gadm_1.index, 
        `${ConfigService.getConfig().agol.gadmLayers.gadm_1.fields.name1} ASC`,
        ConfigService.getConfig().agol.gadmLayers.gadm_1.fields.gid0,
        props.state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.gid0]
        );
      }
      
      if(features.length) {
        addResultsAndBenefitsItem(true, features);
      }
    }

    // 2) Breakpoint mode
    else {
      addResultsAndBenefitsItem(true);
    }
  }

  /**
   * Select tab
   * @param index 
   */
   const selectTab = (index: number) => {
    const obj: ILocalState = { ...localState };
    
    obj.hectaresUnderRestorationTab.isActive = index === 0;
    obj.climateImpactsTab.isActive = index === 1;
    obj.biodiversityImpactsTab.isActive = index === 2;
    obj.socioEconomicImpactsTab.isActive = index === 3;    
    
    setTheLocalState(obj);   
  }
  
  /**
   * Create interventions types tree data
   * @param dataset
   * @returns
   */
   const createIntervTypesDataTree = (dataset: IRefInterventionType[]): any[] => {
    let res: any[] = [];
    dataset.forEach((el: IRefInterventionType) => {
      if (!el.parent_key && el.value) {
        setChildren(el, dataset);
        res.push(getMultiselectItem(el));
      }
    });

    res.sort((a, b) => a.label.localeCompare(b.label));
    
    // Add ecosystems on top level (multiply ecosystem_id by 1000 to resolve tree problem)
    const addedEcosystemsIds: number[] = [];
    const ecosystemsItems: any[] = [];
    res.forEach((el: IRefInterventionType) => {
      if (el.ecosystem_id && addedEcosystemsIds.indexOf(Number(el.ecosystem_id) * 1000) === -1) {
        ecosystemsItems.push({label: el.ecosystem, id: Number(el.ecosystem_id) * 1000, children: [], className: "treeFirstLevel"});
        addedEcosystemsIds.push(Number(el.ecosystem_id) * 1000)
      }
    });

    // Set parent key
    res.forEach((el: IRefInterventionType) => {
      if (!el.parent_key && el.key_) {
        el.parent_key = Number(el.ecosystem_id) * 1000
      }
    });

    ecosystemsItems.forEach((item: any) => {
      res.forEach((el: IRefInterventionType, i: number) => {
        if (el.parent_key === item.id) {
          item.children.push(el);
        }
      });
    });

    ecosystemsItems.sort((a, b) => a.label.localeCompare(b.label));
    return ecosystemsItems;
  };

  const setChildren = (item: IRefInterventionType, dataset: IRefInterventionType[]) => {

    dataset.forEach((el: IRefInterventionType) => {
      if (el.value && el.parent_key === item.key_) {
        setChildren(el, dataset);
        if (item.children) {
          const exists = item.children.find(i => i.key_ === el.key_);

          if(!exists) {
            item.children.push(getMultiselectItem(el));
          }
        } else {
          item.children = [getMultiselectItem(el)];
        }

        item.children.sort((a, b) => a.label.localeCompare(b.label));
      }
    });
  }

  const getMultiselectItem = (item: IRefInterventionType) => {
    return { ...item, ... {label: item.value, id: item.key_}};
  }

  /**
   * Get selected restoration intervention
   * @param date
   */
   const getSelectedRestorationIntervention = (): {label: string | undefined, value: string | undefined}[] | undefined => {
    const filterArr: any[] = localState.refInterventionTypeFeatures
    .filter((i: IRefInterventionType) => (getSelectedResultsAndBenefitsItem()?.hectaresUnderRestorationTab?.ha_intervention_types || '').split(',').indexOf(i.key_?.toString() || '---') !== -1)
    .map((i: IRefInterventionType) => {return {label: i.value, id: i.key_}});
    
    return filterArr && filterArr.length ? filterArr : [];
  }

  /**
   * Add new results and benefits Item
   * @param clearItems 
   * @param features
   */
  const addResultsAndBenefitsItem = (clearItems: boolean = false, features: IFeature[] = Object.create(null) ) => {
    if(props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const rbTab: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;
      const metaTab: IMetadataModalityTab = { ...obj.metadataModalityTab } as IMetadataModalityTab;
      const items = features && features.length ? features.reverse().map( (feat: IFeature, i: number) => initRBItem(feat)) : [];
      
      const oneItem:IResultsAndBenefitsItem = items && items.length ? items[0] : initRBItem(Object.create(null));

      // Is Global
      if(oneItem.gid1 || oneItem.gid2) {
        rbTab.isGlobalMode = false;
      } else {
        rbTab.isGlobalMode = true;
      }

      // Clear items
      if(clearItems) {
        // Store delete objects ids
        setDeleteObjectids(rbTab);

        rbTab.resultsAndBenefitsItems = [];
      }

      // Add new results and benefits Item
      rbTab.resultsAndBenefitsItems = items && items.length ? items.reverse() : [oneItem];

      rbTab.resultsAndBenefitsItems?.forEach( (p: IResultsAndBenefitsItem, i: number) => {
        p.isActive = i === 0;
      });

      // Delete empty items
      if(rbTab.resultsAndBenefitsItems && rbTab.resultsAndBenefitsItems?.length > 1) {
        rbTab.resultsAndBenefitsItems = rbTab.resultsAndBenefitsItems?.filter( (p: IResultsAndBenefitsItem) => {
          return p.gid1 || p.gid2;
        });
      }

      obj.resultsAndBenefitsTab = rbTab;
      
      // Validate data
      props.validateData(rbTab, metaTab);

      props.setState(obj);
    }
  }

  /**
   * Set delete objectis
   * @param tab
   */
  const setDeleteObjectids = (tab: IResultsAndBenefitsTab) => {
    tab.deleteRbObjetIds = tab.resultsAndBenefitsItems && tab.resultsAndBenefitsItems.length ? tab.resultsAndBenefitsItems?.map( (p: IResultsAndBenefitsItem) => { return p.OBJECTID; }) : [];
    const deleteRbJobsObjetIds: number[] = [];

    if(tab.resultsAndBenefitsItems && tab.resultsAndBenefitsItems.length) {
      tab.resultsAndBenefitsItems?.forEach( (p: IResultsAndBenefitsItem) => { 
        if (p.socioEconomicImpactsTab) {
          if (p.socioEconomicImpactsTab.seasonalCasualOccasional && p.socioEconomicImpactsTab.seasonalCasualOccasional.OBJECTID && p.socioEconomicImpactsTab.seasonalCasualOccasional.OBJECTID > 0) {
            deleteRbJobsObjetIds.push(p.socioEconomicImpactsTab.seasonalCasualOccasional.OBJECTID);
          }

          if (p.socioEconomicImpactsTab.shortTerm && p.socioEconomicImpactsTab.shortTerm.OBJECTID && p.socioEconomicImpactsTab.shortTerm.OBJECTID > 0) {
            deleteRbJobsObjetIds.push(p.socioEconomicImpactsTab.shortTerm.OBJECTID);
          }

          if (p.socioEconomicImpactsTab.longTerm && p.socioEconomicImpactsTab.longTerm.OBJECTID && p.socioEconomicImpactsTab.longTerm.OBJECTID > 0) {
            deleteRbJobsObjetIds.push(p.socioEconomicImpactsTab.longTerm.OBJECTID);
          }

          if (p.socioEconomicImpactsTab.unspecified && p.socioEconomicImpactsTab.unspecified.OBJECTID && p.socioEconomicImpactsTab.unspecified.OBJECTID > 0) {
            deleteRbJobsObjetIds.push(p.socioEconomicImpactsTab.unspecified.OBJECTID);
          }
        }
      })
    }

    tab.deleteRbJobsObjetIds = deleteRbJobsObjetIds;
  }

  /**
   * Init results and benefits item
   * @param feature
   * @returns
   */
  const initRBItem = (feature: IFeature = Object.create(null)) => {
    const atts: any = feature ? feature.attributes : null;
    const item: IResultsAndBenefitsItem = {
      isActive: true,
      isOK: false,
      name1: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_1.fields.name1] : undefined,
      gid1: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_1.fields.gid1] : undefined,
      name2: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_2.fields.name2] : undefined,
      gid2: atts ? atts[ConfigService.getConfig().agol.gadmLayers.gadm_2.fields.gid2] : undefined,
      OBJECTID: -1,
      report_id: props.state.report?.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.reportID],
      hectaresUnderRestorationTab: {
        isOK: false,
        ha_intervention_types: ''
      }, 
      climateImpactsTab: {
        isOK: true
      }, 
      biodiversityImpactsTab: {
        isOK: true
      }, 
      socioEconomicImpactsTab: {
        isOK: true,
        seasonalCasualOccasional: {OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType},
        shortTerm: {OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.shortTermType},
        longTerm: {OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType},
        unspecified: {OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.unspecifiedType}
      }
    }

    return item;
  }

  /**
   * Set selected results and benefits Item
   * @param tabIndex
   * @param prop
   * @param value 
   */
   const updateSelectedResultsAndBenefitsItem = (tabIndex: number, prop: string, value: any) => {

    if(props.state) {
      const selectedItem: IResultsAndBenefitsItem | undefined = getSelectedResultsAndBenefitsItem();
      const selectedItemIndex: number = getSelectedResultsAndBenefitsItemIndex();

      if(selectedItemIndex !== -1 && selectedItemIndex !== undefined && selectedItem) {
        const obj: IEditReportState = { ...props.state } as IEditReportState;
        const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;
        const metaTab: IMetadataModalityTab = { ...obj.metadataModalityTab } as IMetadataModalityTab;
        const selectedItemCopy: IResultsAndBenefitsItem = { ...selectedItem };

        switch (tabIndex) {
          case 0:
            (selectedItemCopy.hectaresUnderRestorationTab as any)[prop] = value;
          break;

          case 1:
            (selectedItemCopy.climateImpactsTab as any)[prop] = value;
          break;

          case 2:
            (selectedItemCopy.biodiversityImpactsTab as any)[prop] = value;
          break;

          case 3:
            (selectedItemCopy.socioEconomicImpactsTab as any)[prop] = value;
          break;
        }

        if(subObj.resultsAndBenefitsItems) {
          subObj.resultsAndBenefitsItems[selectedItemIndex] = selectedItemCopy;
          obj.resultsAndBenefitsTab = subObj;

          // Validate data
          props.validateData(subObj, metaTab);
          
          props.setState(obj);
        }
      }
    }
  }

  /**
   * Set selected socio-economic impact item
   * @param tabIndex
   * @param prop
   * @param value 
   */
   const updateSelectedSocioEconomicImpactItem = (accordianIndex: number, prop: string, value: any) => {

    if(props.state) {
      const selectedItem: IResultsAndBenefitsItem | undefined = getSelectedResultsAndBenefitsItem();
      const selectedItemIndex: number = getSelectedResultsAndBenefitsItemIndex();

      if(selectedItemIndex !== -1 && selectedItemIndex !== undefined && selectedItem) {
        const obj: IEditReportState = { ...props.state } as IEditReportState;
        const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;
        const metaTab: IMetadataModalityTab = { ...obj.metadataModalityTab } as IMetadataModalityTab;
        const selectedItemCopy: IResultsAndBenefitsItem = { ...selectedItem };

        switch (accordianIndex) {
          case 0:
            (selectedItemCopy.socioEconomicImpactsTab?.seasonalCasualOccasional as any)[prop] = value;
          break;

          case 1:
            (selectedItemCopy.socioEconomicImpactsTab?.shortTerm as any)[prop] = value;
          break;

          case 2:
            (selectedItemCopy.socioEconomicImpactsTab?.longTerm as any)[prop] = value;
          break;

          case 3:
            (selectedItemCopy.socioEconomicImpactsTab?.unspecified as any)[prop] = value;
          break;
        }

        if(subObj.resultsAndBenefitsItems) {
          subObj.resultsAndBenefitsItems[selectedItemIndex] = selectedItemCopy;
          obj.resultsAndBenefitsTab = subObj;

          // Validate data
          props.validateData(subObj, metaTab);
          
          props.setState(obj);
        }
      }
    }
  }

  /**
   * Select results and benefits Item
   * @param index 
   */
   const selectResultsAndBenefitsItem = (index: number) => {
    if(props.state) {
      const obj: IEditReportState = { ...props.state } as IEditReportState;
      const subObj: IResultsAndBenefitsTab = { ...obj.resultsAndBenefitsTab } as IResultsAndBenefitsTab;
      let selectectItem: IResultsAndBenefitsItem = Object.create(null);

      subObj.resultsAndBenefitsItems?.forEach( (p: IResultsAndBenefitsItem, i: number) => {
        p.isActive = i === index;

        if(i === index) {
          selectectItem = p;
        }
      });
      
      props.setState(obj);
    }
  }

  /**
   * Handle RevertToGlobal dialog
   */
  const handleRevertToGlobalDialogClose = () => setRevertToGlobalDialogShow(false);
  const handleRevertToGlobalDialogShow = () => setRevertToGlobalDialogShow(true);
  const handleRevertToGlobalConfirmRevert = () => {
    handleBreakdownOrRvertReportConfirm();
    handleRevertToGlobalDialogClose();
  }

  /**
   * Handle initiative change
   * @param date
   */
   const handleCO2EstimationSystemChange = (items: MultiValue<{label: string | undefined, value: string | undefined}>) => {
    updateSelectedResultsAndBenefitsItem(1, ConfigService.getConfig().agol.operationalLayers.reportRb.fields.co2_systems, items && items.length ? items.map(i => i.value).join(',') : '')

    const obj: ILocalState = { ...localState };
    obj.otherCO2EstimationSystemInputEnabled = items && items.some((i: any) => i.value === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
    setTheLocalState(obj);
  }

  /**
   * Check if a field is required in hectaresUnderRestorationTab tab
   * @param field
   */
   const isRequiredHecUnderRest = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRb.requiredFields.hectaresUnderRestoration, field);
  }

  /**
   * Check if a field is required in climateImpactsTab tab
   * @param field
   */
   const isRequiredClimImp = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRb.requiredFields.climateImpacts, field);
  }

  /**
   * Check if a field is required in biodiversityImpactsTab tab
   * @param field
   */
   const isRequiredBioImp = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRb.requiredFields.biodiversityImpacts, field);
  }

  /**
   * Check if a field is required in socioEconomicImpactsTab tab
   * @param field
   */
   const isRequiredSociEcoImp = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportRbJobs.requiredFields, field);
  }
  
  const onInterventionTypesToggle = (currentNode: any) => {
    const obj = localState;
    
    obj.treeData.forEach((item: any) => {
      if(item.id === currentNode.id) {
        item.expanded = currentNode.expanded;
      }
    });
    
    setTheLocalState(obj);
  };

  const setExpanded = (items: any[], id: number, expanded: boolean) => {
    items.forEach((item: any) => {
      if(item.id === id) {
        item.expanded = expanded;
      } else if (item.children) {
        setExpanded(item.children, id, expanded);
      }
    });
  }

  const onInterventionTypesChange = (currentNode: any, selectedNodes: any[]) => {
    let types = '';
    let ids = [];

    if (selectedNodes && selectedNodes.length) {
      const obj = localState;
      if (currentNode.parent_key) {
        setExpanded(obj.treeData, currentNode.parent_key, true)
      }
      
      setTheLocalState(obj);
      types = selectedNodes && selectedNodes.length ? selectedNodes.map(i => i.id).join(',') : '';
      ids = selectedNodes && selectedNodes.length ? selectedNodes.map(i => i.id) : [];
    }

    updateSelectedResultsAndBenefitsItem(0, 'ha_intervention_types', types);
    callSetSelectedInterventionTypes(ids);    
  };

  const callSetSelectedInterventionTypes = (ids: number[]) => {
    setSelectedInterventionTypes(localState.treeData, ids);
    const obj: ILocalState = { ...localState };
    obj.treeData = localState.treeData;
    setTheLocalState(obj);
  };

  const setSelectedInterventionTypes = (items: any[], ids: number[]) => {    
    items.forEach((item: any) => {
      item.checked = ids.indexOf(item.id) !== -1;
    
      if (item.children) {
        setSelectedInterventionTypes(item.children, ids);
      }
    });
  };

  return(
    <div className="oneTabContent resultsAndBenefitsTab row">
      <div className="itemsLeft">
        <div className="breakdownReportByStatesDiv">
          <button className="actionBtn primary" onClick={handleBreakdownOrRvertReportClick}>
              {props.state.resultsAndBenefitsTab?.isGlobalMode &&<span>{props.state.report?.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name1 || ''] ? t('newReport.resultsAndBenefits.breakdownReportByDistricts') : t('newReport.resultsAndBenefits.breakdownReportByStates')}</span>}
              {!props.state.resultsAndBenefitsTab?.isGlobalMode && <span>{t('newReport.resultsAndBenefits.revertToGlobalReport')}</span>}
          </button>   
        </div>

        {!props.state.resultsAndBenefitsTab?.isGlobalMode &&
        <div className="itemsList">
          {props.state.resultsAndBenefitsTab?.resultsAndBenefitsItems?.map((p:IResultsAndBenefitsItem, i: number) =>
            <div className={`oneItem ${p.isActive ? 'active' : p.isOK ? 'ok' : 'default'}`} key={i} onClick={ () => {selectResultsAndBenefitsItem(i)}}>
              <span className="tabSpan">{p.name2 !== null && p.name2 !== undefined && p.name2 !== '' ? p.name2 : p.name1}</span>
              {!p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={ p.isOK ? faCheck :  faTimes}/>}
              
              {p.isActive &&
              <div className="oneItemContent">
                <p className={`subTabItem ${p.isActive && p.hectaresUnderRestorationTab.isOK && 'ok'}`}>
                  <span className="commonText">5. {t('newReport.resultsAndBenefits.hectaresUnderRestorationLabel')}</span>
                  {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={ p.hectaresUnderRestorationTab.isOK ? faCheck :  faTimes}/>}
                </p>

                <p className={`subTabItem ${p.isActive && p.climateImpactsTab.isOK && 'ok'}`}>
                  <span className="commonText">6. {t('newReport.resultsAndBenefits.climateImpactsLabel')}</span>
                  {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={ p.climateImpactsTab.isOK ? faCheck :  faTimes}/>}
                </p>

                <p className={`subTabItem ${p.isActive && p.biodiversityImpactsTab.isOK && 'ok'}`}>
                  <span className="commonText">7. {t('newReport.resultsAndBenefits.biodiversityImpactsLabel')}</span>
                  {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={ p.biodiversityImpactsTab.isOK ? faCheck :  faTimes}/>}
                </p>

                <p className={`subTabItem ${p.isActive && p.socioEconomicImpactsTab?.isOK && 'ok'}`}>
                  <span className="commonText">8. {t('newReport.resultsAndBenefits.socioEconomicImpactsLabel')}</span>
                  {p.isActive && <FontAwesomeIcon className="tabIcon checkIcon" icon={ p.socioEconomicImpactsTab?.isOK ? faCheck :  faTimes}/>}
                </p>
              </div>
              }
            </div>
          )}
        </div>
        }
      </div>
      <div className="itemsRight">
        <div className="tabsHeaderDiv">
          <div className={`oneTabItem ${localState.hectaresUnderRestorationTab.isActive ? 'active' : localState.hectaresUnderRestorationTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(0)}>5. {t('newReport.resultsAndBenefits.hectaresUnderRestorationLabel')}</div>
          <div className={`oneTabItem ${localState.climateImpactsTab.isActive ? 'active' : localState.climateImpactsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(1)}>6. {t('newReport.resultsAndBenefits.climateImpactsLabel')}</div>
          <div className={`oneTabItem ${localState.biodiversityImpactsTab.isActive ? 'active' : localState.biodiversityImpactsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(2)}>7. {t('newReport.resultsAndBenefits.biodiversityImpactsLabel')}</div>
          <div className={`oneTabItem ${localState.socioEconomicImpactsTab.isActive ? 'active' : localState.socioEconomicImpactsTab.isDisabled ? 'disabled default' : 'default'}`} onClick={() => selectTab(3)}>8. {t('newReport.resultsAndBenefits.socioEconomicImpactsLabel')}</div>
        </div>

        <div className="tabsContentDiv">
          <div className="borderHider">
            <div className={`oneBorderHider ${localState.hectaresUnderRestorationTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.climateImpactsTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.biodiversityImpactsTab.isActive ? 'active' : ''}`}></div>
            <div className={`oneBorderHider ${localState.socioEconomicImpactsTab.isActive ? 'active' : ''}`}></div>
          </div>

          {/*hectaresUnderRestorationTab */
          localState.hectaresUnderRestorationTab.isActive &&
          <div>
            <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">5</span>
                <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.hectaresUnderRestorationLabel')}</span>              
              </div>
              
              <p className="oneTabIntroText">{t('newReport.resultsAndBenefits.hectaresUnderRestorationIntro')}</p>
            </div>
            
            {getSelectedResultsAndBenefitsItem() &&
            <div>              
              <div className="row multiselectRow required">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.restorationInterventions')}</span>
                <p>

                {localState.refPledgeEcosystemTypeFeatures && localState.refPledgeEcosystemTypeFeatures.length > 0 &&
                <DropdownTreeSelect
                    data={localState.treeData} showPartiallySelected={true}
                    onChange={onInterventionTypesChange}
                    onNodeToggle={onInterventionTypesToggle}
                    className="rbInterventionTypes big"/>
                }
                </p>
              </div>
              
              
              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.hectareNumber')}</span>                       
                <input className="mediumText small hidearrows" required = {isRequiredHecUnderRest('ha_under_resto')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'ha_under_resto')?.length || 9999} min={0} step={0.1} onKeyUp={Utils.preventNegativeValueFloat}
                type="number" placeholder={t('newReport.resultsAndBenefits.hectareNumberPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.hectaresUnderRestorationTab?.ha_under_resto || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(0, 'ha_under_resto', e.target.value)}}/>  
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.implementationYear')}</span>                       
                <input className="mediumText small" required = {isRequiredHecUnderRest('ha_imp_year')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'ha_imp_year')?.length || 9999} min={1900} max={2100} onKeyUp={Utils.validateYear}
                type="number" placeholder={t('newReport.resultsAndBenefits.implementationYearPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.hectaresUnderRestorationTab?.ha_imp_year || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(0, 'ha_imp_year', e.target.value)}}/>  
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.dataClassification')}</span>
                <select className={`mediumText small ${isRequiredHecUnderRest('ha_tier') ? "required": ""}`}
                  value={getSelectedResultsAndBenefitsItem()?.hectaresUnderRestorationTab?.ha_tier || '-999'}
                  onChange={(e) => {updateSelectedResultsAndBenefitsItem(0, 'ha_tier', e.target.value)}}>
                  {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                  {localState.tiersFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                  </select>
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.relevantCitations')}</span>             
                <textarea className="commonText big" required = {isRequiredHecUnderRest('ha_links')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'ha_links')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.relevantCitationsPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.hectaresUnderRestorationTab?.ha_links || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(0, 'ha_links', e.target.value)}}/> 
              
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.relevantInformation')}</span>
                <textarea className="commonText big" required = {isRequiredHecUnderRest('ha_information')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'ha_information')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.relevantInformationPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.hectaresUnderRestorationTab?.ha_information || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(0, 'ha_information', e.target.value)}}/>
              </div>
            </div>
            }
          </div>
          }

          {/*climateImpactsTab */
          localState.climateImpactsTab.isActive &&
          <div className='climateImpactsTab'>
            <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">6</span>
                <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.climateImpactsLabel')}</span>              
              </div>
              
              <p className="oneTabIntroText">{t('newReport.resultsAndBenefits.climateImpactsIntro')}</p>
            </div>

            {getSelectedResultsAndBenefitsItem() &&
            <div>
              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.co2SequesteredLabel')}</span>                       
                <input className="mediumText small" required = {isRequiredClimImp('co2_sequestered')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_sequestered')?.length || 9999} min={0}  step={0.1} onKeyUp={Utils.preventNegativeValueFloat}
                type="number" placeholder={t('newReport.resultsAndBenefits.co2SequesteredPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.climateImpactsTab?.co2_sequestered || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(1, 'co2_sequestered', e.target.value)}}/>  
              </div>

              <div className={`row multiselectRow ${isRequiredClimImp('co2_systems') ? "required": ""}`}>
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.co2SystemsLabel')}</span>

                <div className="col-6">
                  <Select classNamePrefix="multiselect" placeholder={t('newReport.resultsAndBenefits.multiselectPlaceholder')}
                  closeMenuOnSelect={true} isMulti
                  options={localState.refCO2EstimationSystemFeatures.map((i: IRefCO2EstimationSystem) => {return {label: i.value, value: i.key_}})}
                  onChange={handleCO2EstimationSystemChange}
                  value={
                    localState.refCO2EstimationSystemFeatures.map((i: IRefCO2EstimationSystem) => {return {label: i.value, value: i.key_}})
                    .filter( (option: any) => (getSelectedResultsAndBenefitsItem()?.climateImpactsTab?.co2_systems || '').split(',').indexOf(option.value) !== -1)
                  }/>
                </div>

                <div className="col-6">
                  <input className="mediumText medium right" required = {isRequiredClimImp('co2_other')}
                  maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                  type="text" disabled={!localState.otherCO2EstimationSystemInputEnabled} value={getSelectedResultsAndBenefitsItem()?.climateImpactsTab.co2_other} onChange={(e) => {updateSelectedResultsAndBenefitsItem(1, 'co2_other', e.target.value)}}/>  
                </div>
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.co2TierLabel')}</span>
                <select className={`mediumText small ${isRequiredClimImp('co2_tier') ? "required": ""}`}
                  value={getSelectedResultsAndBenefitsItem()?.climateImpactsTab?.co2_tier || '-999'}
                  onChange={(e) => {updateSelectedResultsAndBenefitsItem(1, 'co2_tier', e.target.value)}}>
                  {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                  {localState.tiersFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                </select>
              </div>

              <div className="row">
                  <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" id="isPriorityCbx" checked={getSelectedResultsAndBenefitsItem()?.climateImpactsTab.co2_contribution == 1} onChange={(e) => {updateSelectedResultsAndBenefitsItem(1, 'co2_contribution', e.target.checked ? 1 : 0)}}/>
                      <label className="form-check-label mediumText" htmlFor="isPriorityCbx">{t('newReport.resultsAndBenefits.co2ContributionLabel')}</label>
                  </div>
              </div>
              
              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.co2LinksLabel')}</span>
                <textarea className="commonText big" required = {isRequiredClimImp('co2_links')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_links')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.co2LinksPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.climateImpactsTab.co2_links || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(1, 'co2_links', e.target.value)}}/> 
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.co2InformationLabel')}</span>
                <textarea className="commonText big" required = {isRequiredClimImp('co2_information')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'co2_information')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.co2InformationPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.climateImpactsTab.co2_information || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(1, 'co2_information', e.target.value)}}/> 
              </div>

            </div>
            }
          </div>
          }

          {/*biodiversityImpactsTab */
          localState.biodiversityImpactsTab.isActive &&
          <div className="biodiversityImpactsTab">
            <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">7</span>
                <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.biodiversityImpactsLabel')}</span>              
              </div>
              
              <p className="oneTabIntroText">{t('newReport.resultsAndBenefits.biodiversityImpactsIntro')}</p>
            </div>

            {getSelectedResultsAndBenefitsItem() &&
            <div>
              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.bioHaThreatSpeciesLabel')}</span>                       
                <input className="mediumText small" required = {isRequiredBioImp('bio_ha_threat_species')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_ha_threat_species')?.length || 9999} min={0} step={0.1} onKeyUp={Utils.preventNegativeValueFloat}
                type="number" placeholder={t('newReport.resultsAndBenefits.bioHaThreatSpeciesPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_ha_threat_species || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_ha_threat_species', e.target.value)}}/>  
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.bioProtAreaHaLabel')}</span>                       
                <input className="mediumText verySmall" required = {isRequiredBioImp('bio_protarea_ha')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_protarea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                type="number" placeholder={t('newReport.resultsAndBenefits.bioProtAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_protarea_ha || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_protarea_ha', e.target.value)}}/>  
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.bioAreaHaLabel')}</span>
                
                <p>
                  <span className="titleSpan mediumText sameLineElem">{t('newReport.resultsAndBenefits.bioNativeAreaHaLabel')}</span>                       
                  <input className="mediumText verySmall sameLineElem" required = {isRequiredBioImp('bio_nativearea_ha')}
                  maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_nativearea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                  type="number" placeholder={t('newReport.resultsAndBenefits.bioAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_nativearea_ha || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_nativearea_ha', e.target.value)}}/>  

                  <span className="titleSpan mediumText sameLineElem">{t('newReport.resultsAndBenefits.bioPrimAreaHaLabel')}</span>                       
                  <input className="mediumText verySmall sameLineElem" required = {isRequiredBioImp('bio_primarea_ha')}
                  maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_primarea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                  type="number" placeholder={t('newReport.resultsAndBenefits.bioAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_primarea_ha || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_primarea_ha', e.target.value)}}/>  

                  <span className="titleSpan mediumText sameLineElem">{t('newReport.resultsAndBenefits.bioIntactAreaHaLabel')}</span>                       
                  <input className="mediumText verySmall sameLineElem" required = {isRequiredBioImp('bio_intactarea_ha')}
                  maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_intactarea_ha')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue} max={100}
                  type="number" placeholder={t('newReport.resultsAndBenefits.bioAreaHaPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_intactarea_ha || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_intactarea_ha', e.target.value)}}/>  
                </p>
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.bioRedlistLabel')}</span>                   
                <textarea className="mediumText veryBig" required = {isRequiredBioImp('bio_redlist')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_redlist')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.bioRedlistPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_redlist || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_redlist', e.target.value)}}/>  
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.bioLinksLabel')}</span>                       
                <textarea className="mediumText veryBig" required = {isRequiredBioImp('bio_links')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_links')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.bioLinksPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_links || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_links', e.target.value)}}/>  
              </div>

              <div className="row">
                <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.bioInformationLabel')}</span>                       
                <textarea className="mediumText veryBig" required = {isRequiredBioImp('bio_information')}
                maxLength={Utils.getFieldInfos(localState.reportRBLayerIndex, 'bio_information')?.length || 9999}
                rows={5} placeholder={t('newReport.resultsAndBenefits.bioInformationPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.biodiversityImpactsTab?.bio_information || ''} onChange={(e) => {updateSelectedResultsAndBenefitsItem(2, 'bio_information', e.target.value)}}/>  
              </div>

            </div>
            }
          </div>
          }

          {/*socioEconomicImpactsTab */
          localState.socioEconomicImpactsTab.isActive &&
          <div className="socioEconomicImpactsTab">
             <div className="oneTabIntro">
              <div className="oneTabIntroNumAndTitle">
                <span className="oneTabIntroNumber">8</span>
                <span className="oneTabIntroTitle">{t('newReport.resultsAndBenefits.socioEconomicImpactsLabel')}</span>              
              </div>
              
              <p className="oneTabIntroText">{t('newReport.resultsAndBenefits.socioEconomicImpactsIntro')}</p>
            </div>

            {getSelectedResultsAndBenefitsItem() &&
            <div className="accordionDiv">
              <Accordion>
                {/** seasonalCasualOccasional*/}
                <Accordion.Item eventKey="0">
                  <Accordion.Header>{t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel1')}</Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoJobsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_jobs')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_jobs')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoJobsLabelPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_jobs || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_jobs', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoUnitLabel')}</span>
                      
                      <div className="col-4"> 
                        <select className={`mediumText halfSelect ${isRequiredSociEcoImp('eco_unit') ? "required" : ""}`}
                          value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_unit || '-999'}
                          onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_unit', e.target.value)}}>
                          {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                          {localState.refJobMeasureUnitFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                      </div>

                      <div className="col-8"> 
                        <input className="mediumText right" type="text" required = {isRequiredSociEcoImp('eco_other')}
                        maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                        disabled={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_unit !== ConfigService.getConfig().agol.referenceTables.otherKeyValue} 
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_other || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_other', e.target.value)}}/>  
                      </div>
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoHeadcountsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_headcounts')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_headcounts')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoHeadcountsPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_headcounts || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_headcounts', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoMaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_male')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_male')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoMalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_male || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_male', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoFemaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_female')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_female')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoFemalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_female || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_female', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoThirdLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_third')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_third')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoThirdPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_third || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_third', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoTiersLabel')}</span>
                      <select className={`mediumText small ${isRequiredSociEcoImp('eco_tiers') ? "required" : ""}`}
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.seasonalCasualOccasional?.eco_tiers || '-999'}
                        onChange={(e) => {updateSelectedSocioEconomicImpactItem(0, 'eco_tiers', e.target.value)}}>
                        {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                        {localState.tiersFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/** shortTerm*/}
                <Accordion.Item eventKey="1">
                  <Accordion.Header>{t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel2')}</Accordion.Header>
                  <Accordion.Body>
                  <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoJobsLabel')}</span>                       
                      <input className="mediumText small"  required = {isRequiredSociEcoImp('eco_jobs')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_jobs')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoJobsLabelPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_jobs || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_jobs', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoUnitLabel')}</span>
                      
                      <div className="col-4"> 
                        <select className={`mediumText halfSelect ${isRequiredSociEcoImp('eco_unit') ? "required" : ""}`}
                          value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_unit || '-999'}
                          onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_unit', e.target.value)}}>
                          {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                          {localState.refJobMeasureUnitFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                      </div>

                      <div className="col-8"> 
                        <input className="mediumText right" type="text" required = {isRequiredSociEcoImp('eco_other')}
                        maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                        disabled={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_unit !== ConfigService.getConfig().agol.referenceTables.otherKeyValue} 
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_other || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_other', e.target.value)}}/>  
                      </div>
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoHeadcountsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_headcounts')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_headcounts')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoHeadcountsPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_headcounts || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_headcounts', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoMaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_male')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_male')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoMalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_male || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_male', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoFemaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_female')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_female')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoFemalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_female || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_female', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoThirdLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_third')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_third')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoThirdPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_third || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_third', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoTiersLabel')}</span>
                      <select className={`mediumText small ${isRequiredSociEcoImp('eco_tiers') ? "required" : ""}`}
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.shortTerm?.eco_tiers || '-999'}
                        onChange={(e) => {updateSelectedSocioEconomicImpactItem(1, 'eco_tiers', e.target.value)}}>
                        {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                        {localState.tiersFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/** longTerm*/}
                <Accordion.Item eventKey="2">
                  <Accordion.Header>{t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel3')}</Accordion.Header>
                  <Accordion.Body>
                  <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoJobsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_jobs')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_jobs')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoJobsLabelPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_jobs || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_jobs', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoUnitLabel')}</span>
                      
                      <div className="col-4"> 
                        <select className={`mediumText halfSelect ${isRequiredSociEcoImp('eco_unit') ? "required" : ""}`}
                          value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_unit || '-999'}
                          onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_unit', e.target.value)}}>
                          {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                          {localState.refJobMeasureUnitFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                      </div>

                      <div className="col-8"> 
                        <input className="mediumText right" type="text" required = {isRequiredSociEcoImp('eco_other')}
                        maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                        disabled={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_unit !== ConfigService.getConfig().agol.referenceTables.otherKeyValue} 
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_other || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_other', e.target.value)}}/>  
                      </div>
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoHeadcountsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_headcounts')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_headcounts')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoHeadcountsPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_headcounts || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_headcounts', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoMaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_male')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_male')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoMalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_male || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_male', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoFemaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_female')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_female')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoFemalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_female || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_female', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoThirdLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_third')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_third')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoThirdPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_third || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_third', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoTiersLabel')}</span>
                      <select className={`mediumText small ${isRequiredSociEcoImp('eco_tiers') ? "required" : ""}`}
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.longTerm?.eco_tiers || '-999'}
                        onChange={(e) => {updateSelectedSocioEconomicImpactItem(2, 'eco_tiers', e.target.value)}}>
                        {<option value="-999" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                        {localState.tiersFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                {/** unspecified*/}
                <Accordion.Item eventKey="3">
                  <Accordion.Header>{t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel4')}</Accordion.Header>
                  <Accordion.Body>
                  <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoJobsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_jobs')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_jobs')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoJobsLabelPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_jobs || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_jobs', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoUnitLabel')}</span>
                      
                      <div className="col-4"> 
                        <select className={`mediumText halfSelect ${isRequiredSociEcoImp('eco_unit') ? "required" : ""}`}
                          value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_unit || ''}
                          onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_unit', e.target.value)}}>
                          {<option value="" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                          {localState.refJobMeasureUnitFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                      </div>

                      <div className="col-8"> 
                        <input className="mediumText right" type="text" required = {isRequiredSociEcoImp('eco_other')}
                        maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_other')?.length || 9999} placeholder={t('newReport.ifOtherSelected')}
                        disabled={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_unit !== ConfigService.getConfig().agol.referenceTables.otherKeyValue} 
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_other || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_other', e.target.value)}}/>  
                      </div>
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoHeadcountsLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_headcounts')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_headcounts')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoHeadcountsPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_headcounts || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_headcounts', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoMaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_male')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_male')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoMalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_male || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_male', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoFemaleLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_female')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_female')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoFemalePlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_female || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_female', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoThirdLabel')}</span>                       
                      <input className="mediumText small" required = {isRequiredSociEcoImp('eco_third')}
                      maxLength={Utils.getFieldInfos(localState.reportRBJobsLayerIndex, 'eco_third')?.length || 9999} min={0} onKeyUp={Utils.preventNegativeValue}
                      type="number" placeholder={t('newReport.resultsAndBenefits.ecoThirdPlaceholder')} value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_third || ''} onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_third', e.target.value)}}/>  
                    </div>

                    <div className="row">
                      <span className="titleSpan mediumText">{t('newReport.resultsAndBenefits.ecoTiersLabel')}</span>
                      <select className={`mediumText small ${isRequiredSociEcoImp('eco_tiers') ? "required" : ""}`}
                        value={getSelectedResultsAndBenefitsItem()?.socioEconomicImpactsTab?.unspecified?.eco_tiers || ''}
                        onChange={(e) => {updateSelectedSocioEconomicImpactItem(3, 'eco_tiers', e.target.value)}}>
                        {<option value="" key="">{t('newReport.resultsAndBenefits.selectOnePlacehodler')}</option>}
                        {localState.tiersFeatures.map((i) => <option value={i.key_} key={i.key_}>{i.value}</option>)}
                        </select>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            }
          </div>
          }
        </div>
      </div>

      <Modal show={showRevertToGlobalDialog} onHide={handleRevertToGlobalDialogClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('newReport.resultsAndBenefits.confirmRevertToGlobalTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('newReport.resultsAndBenefits.confirmRevertToGlobalContent')}</Modal.Body>
        <Modal.Footer>
          <button className="dialogBtn secondary" onClick={handleRevertToGlobalDialogClose}>
          {t('newReport.resultsAndBenefits.cancelRevertToGlobal')}
          </button>
          <button className="dialogBtn primary" onClick={handleRevertToGlobalConfirmRevert}>
          {t('newReport.resultsAndBenefits.confirmRevertToGlobal')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ResultsAndBenefits;

